
    var locales = require('../../../../locale-loader/runtime.js');
    module.exports = locales.getLocale({"de":{"title":"Nachricht gesendet"},"en":{"title":"Message sent"},"fr":{"title":"Message envoyé"},"it":{"title":"Messaggio inviato"},"ja":{"title":"メッセージ送信"},"ko":{"title":"메시지 전송"},"ru":{"title":"Сообщение отправлено"},"zh":{"title":"消息已发送"}});
  